export const NEW_LOCATION_VALUE = 'NEW_LOCATION_VALUE'
export const LOCATIONID = 'locationId'